import { Route } from '@angular/router';
import { subscriptionAccessGuard } from '@rma/billing/subscription-plans/public/api-subscription-features';
import { logRedirectGuard, RmaEmptyComponent } from '@rma/generic/util/router-utils';
import { externalProviderGuard } from '@rma/reviews/private/api-external-provider-status';

export const reviewRoutes: Route[] = [
  {
    path: '',
    loadChildren: () => import('@rma/reviews/manager'),
  },
  {
    path: 'upgrade',
    loadChildren: () => import('@rma/reviews/upgrade-landers'),
  },
  {
    path: 'request',
    title: 'Request | Reviews',
    loadChildren: () => import('@rma/reviews/review-request'),
  },
  {
    path: 'completed',
    title: 'Completed | Reviews',
    children: [
      {
        path: ':reviewCode/received',
        loadComponent: () => import('@rma/reviews/received'),
      },
    ],
  },
  {
    path: 'import',
    title: 'Import | Reviews',
    canActivate: [subscriptionAccessGuard('HasImportReviews', '/reviews/upgrade')],
    children: [
      {
        path: '',
        canActivate: [externalProviderGuard],
        component: RmaEmptyComponent,
      },
      {
        path: 'existing',
        loadChildren: () => import('@rma/reviews/add-existing'),
      },
      {
        path: 'external',
        loadChildren: () => import('@rma/reviews/link-external'),
      },
    ],
  },
  // Remove after 2024-06-30 ( check track js for logs)
  {
    path: 'easy-reviews',
    canActivate: [logRedirectGuard('/settings/easy-reviews')],
    component: RmaEmptyComponent,
  },
];
